import {Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewContainerRef} from '@angular/core';
import {AuthService} from '@src/app/Shared/Services/auth.service';
import {IDataDialogContent, ISubmitDialogContent} from "../../../Abstractions/Auth/ISubmitDialogContent";

@Component({
    selector: 'app-decision-dialog',
    imports: [],
    templateUrl: './decision-dialog.component.html',
    styleUrl: './decision-dialog.component.scss'
})
export class DecisionDialogComponent implements OnInit, IDataDialogContent {
  @Output() decision: EventEmitter<void> = new EventEmitter<void>();
  @Input() dialogRef!: ViewContainerRef;
  @Input() data?: ISubmitDialogContent;

  constructor( private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  clearStyle() {
    this.renderer.removeStyle(document.body, 'overflow');
  }

  confirmAction() {
    this.clearStyle();
    this.decision.emit();
    this.dialogRef.clear();
  }

  cancelAction() {
    this.clearStyle();
    this.dialogRef.clear();
  }
}
